<template>
  <div class="relative">
    <div ref="container" class="w-16 h-16"></div>
    <div class="absolute left-0 top-0.5 w-full h-full flex flex-col items-center justify-center">
      <img :src="`${$settings.theme_url}/assets/images/icons/icn-blue-rating-star.svg`" alt="" />
      <span class="text-md" ref="rating" v-text="rating"></span>
    </div>
  </div>
</template>
<script>
import ProgressBar from "progressbar.js"
export default {
  props: {
    score: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      rating: 0,
      bar: {},
    }
  },
  mounted() {
    this.bar = new ProgressBar.Circle(this.$refs.container, {
      strokeWidth: 3,
      easing: "easeInOut",
      duration: 1400,
      color: "#0F4859",
      trailColor: "#D1D5DB",
      trailWidth: 1,
      svgStyle: null,
      step: (state, circle) => {
        this.rating = Math.round(circle.value() * 100)
      },
    })

    document.addEventListener("scroll", (e) => {
      let rect = this.$refs.rating.getBoundingClientRect()

      if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
        if (parseInt(this.rating) === 0) {
          // init only once
          this.bar.animate(this.score / 100) // Number from 0.0 to 1.0
        }
      }
    })
  },
}
</script>
